
import Vue from 'vue'
import { mapActions } from 'vuex'

import { ethers } from 'ethers'
import { IEcosystem, EcosystemId, ECOSYSTEMS, ChainId } from '@/ecosystem'

import { tokenInfo } from '@/mixins/tokenInfo'

import {
    ERC20_ABI,
    SWAP_ROUTER_ABI
} from '@/constants'

export default Vue.extend({
  name: 'TokenSelector',
  mixins: [tokenInfo],
  props: {
    selectedToken: Object,
    tokenWhitelist: Array
  },
  data() {
      return {
          dialog: <boolean> false,
          customTokenAddress: <String> '',
          customToken: <any> {},
          customTokenLoading: <boolean> false,
          customTokenAddressIsValid: <boolean> false,
          filteredTokenList: <any> []
      }
  },
  computed: {
      userAddress(): string {
        return this.$store.state.address
      },
      multicall(): ethers.providers.Provider {
        return this.$store.getters.multicall
      },
      ecosystem(): IEcosystem {
        return this.$store.getters.ecosystem
      },
      web3(): ethers.Signer | null {
        return this.$store.state.web3
      },
      chainId(): ChainId {
        return this.$store.getters.ecosystem.chainId
      },
  },
  created() {
    this.updateFilteredTokenList()
  },
  methods: {
    selectToken(tokenData : any) {
      this.$emit('tokenSelected', tokenData)
      this.dialog = false
    },
    async loadCustomTokenData() {
      while (this.customTokenLoading) {}
      this.customTokenLoading = true
      // @ts-ignore-next-line
      const tokenInfo = await this.getTokenData(this.customTokenAddress)
      this.customToken = tokenInfo
      this.customTokenLoading = false
    },

    // Filters the token whitelist,
    // only displaying the tokens that match the search query
    // in their name or adress
    updateFilteredTokenList() {
      const list = []
      for (let i = 0; i < this.tokenWhitelist.length; i++) {
        let token : any = this.tokenWhitelist[i]

        const query = this.customTokenAddress.toUpperCase()
        const address = token.address.toUpperCase()
        const symbol = token.symbol.toUpperCase()
        const name = token.name.toUpperCase()

        if (address.includes(query) || symbol.includes(query) || name.includes(query)) {
          list.push(token)
        }
      }
      this.filteredTokenList = list
    }
  },
  watch: {
    customTokenAddress(val) {
      if (ethers.utils.isAddress(val)) {
        this.loadCustomTokenData()
        this.customTokenAddressIsValid = true
        this.filteredTokenList = []
      }
      else {
        this.customTokenAddressIsValid = false
        this.updateFilteredTokenList()
      }
    },
    tokenWhitelist(newWhitelist) {
      this.updateFilteredTokenList()
    },
  }
})

